import React, { useRef } from 'react';
import clsx from 'clsx';
import { createDescendantContext, DescendantsProvider, useDescendantsContextSelector, } from '../Descandants';
import { TabsPanel } from './TabsPanel';
import { TabsTablist } from './TabsTabList';
import { Box, getBoxRestrictedProperties } from '../Box';
import { useStableCallback } from '../../utils';
import { useUpdateEffect } from '../../utils/useUpdateEffect';
import './Tabs.css';
export const TabsDescendantsContext = createDescendantContext('TabsDescendantsContext');
export function Tabs(props) {
    const { children, variant = 'default', rotate, className, onChange, alignTabs, ...rest } = props;
    const tabsOnlyChildren = React.Children.toArray(children).filter((child) => {
        if (React.isValidElement(child) && child.type === TabsPanel) {
            return true;
        }
        return false;
    });
    const [boxRestrictedProperties, tabListProps] = getBoxRestrictedProperties(rest);
    return (React.createElement(DescendantsProvider, { context: TabsDescendantsContext },
        React.createElement(Box.Restricted, { ...boxRestrictedProperties, className: clsx('mollie-ui-tabs', {
                [`mollie-ui-tabs--align-${alignTabs}`]: alignTabs,
            }, className) },
            React.createElement(TabsTablist, { ...tabListProps, tabs: tabsOnlyChildren, advanced: variant === 'advanced', filled: variant === 'filled', rotate: rotate !== null && rotate !== void 0 ? rotate : variant === 'default' }),
            React.createElement(TabsContent, { tabs: tabsOnlyChildren, onChange: onChange }))));
}
function TabsContent({ tabs, onChange, }) {
    const selectedDescendant = useDescendantsContextSelector(TabsDescendantsContext, ({ selected }) => selected[0]);
    const tabRef = useRef(null);
    const selectedTab = tabs.find((_, index) => (selectedDescendant === null || selectedDescendant === void 0 ? void 0 : selectedDescendant.index) === index) ||
        tabs.find((tab) => tab.props.defaultSelected === true) ||
        tabs[0];
    const selectedIndex = tabs.indexOf(selectedTab);
    const stableOnChange = useStableCallback(onChange);
    useUpdateEffect(() => {
        stableOnChange === null || stableOnChange === void 0 ? void 0 : stableOnChange(selectedIndex, tabRef.current);
    }, [selectedIndex, stableOnChange]);
    return React.cloneElement(selectedTab, { ref: tabRef });
}
Tabs.Panel = TabsPanel;
//# sourceMappingURL=Tabs.js.map